module.exports = __webpack_public_path__ + "static/media/GillSans.2e40a82b.otf";